import React from "react";
import { string } from "prop-types";

export const propTypes = {
  href: string,
  topic: string,
  title: string,
  subtitle: string,
};

const FeaturedContentCard = (props) => {
  const { href, topic, title, subtitle } = props;
  return (
    <li className="featured-content__list-item">
      <a className="featured-content__card" href={href}>
        <p className="featured-content__card-topic">{topic}</p>
        <h3 className="featured-content__card-title">{title}</h3>
        <p className="featured-content__card-subtitle js-feature-content-subtitle">
          {subtitle}
        </p>
      </a>
    </li>
  );
};

FeaturedContentCard.propTypes = {
  href: string,
  topic: string,
  title: string,
  subtitle: string,
};
export default FeaturedContentCard;
